<template>
  <div>
    <v-checkbox label="Assina CCB" v-model="assinaCCB" @change="retiraPapeis" v-if="!!nomeConjuge" />
    <input-multiselect v-model="model" :options="papeis" label="Papéis" :required="!nomeConjuge || assinaCCB" :disabled="!assinaCCB && !!nomeConjuge" />
  </div>
</template>
<script>
export default {
  props: {
    codigoProposta: String,
    value: [],
    assinante: Object,
    nomeConjuge: String,
    cliente: Object,
  },
  data () {
    return {
      proposta: null,
      listBase: [],
      assinaCCB: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    papeis: {
      get () {
        return this.$param.EST_PAPEIS.map(el => {
          const tipo = this.$api.UI.Format.SomenteAlfanumerico(this.cliente.DocumentoFederal).length === 11 ? 'pf' : 'pj'
          if (el[tipo]) {
            return {
              text: el.tipo === this.$aux.PapelAssinaturaEnum.Avalista ? 'AVALISTA' : el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal),
              value: { Descricao: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal), PapelID: el.tipo },
            }
          }
        })
      },
      set () {
        return this.$param.EST_PAPEIS;
      }
    },
  },
  methods: {
    async submit () {
      const th = this;
      const nomeConjuge = th.nomeConjuge
      const assinante = th.assinante
      if (!th.assinaCCB) {
        th.model = []
      }

      let arrayInclusao = Array.isArray(th.model) ? [...th.model] : [];
      let arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      if (arrayExclusao.length > 0) {
        arrayExclusao = arrayExclusao.map(papel => {
          return papel.Codigo
        })

        await th.$api.Multiplo.RemoveCCBDigitalAssinaturas({ dto: arrayExclusao })
      }

      if (arrayInclusao.length > 0) {
        th.$api.Multiplo.FindRecordProdutoRede().then(function (res) {
          arrayInclusao = arrayInclusao.map(papel => {
            return {
              CodigoProposta: th.codigoProposta,
              Nome: nomeConjuge ? `${assinante.Nome} - CÔNJUGE DE ${nomeConjuge}` : assinante.Nome,
              Email: assinante.Email,
              Documento: assinante.DocumentoFederal,
              TelefoneCelular: assinante.TelefoneCelular,
              Descricao: papel.Descricao,
              PapelID: papel.PapelID,
              NotificarPorEmail: th.$aux.NotificaPorEmail.includes(res.ModeloNotificacaoAssinatura),
              NotificarPorWhatsApp: th.$aux.NotificaPorWhatsApp.includes(res.ModeloNotificacaoAssinatura)
            }
          })

          th.$api.Multiplo.InsertCCBDigitalAssinaturas({ dto: arrayInclusao }).then(resInsert => {
            if (th.$api.UI.PostLoadData(resInsert, true)) { };
          });
        })
      }
    },
    carregarAssinantes () {
      const th = this;
      const dtoAssinantes = {
        parameters: [
          { name: 'CodigoProposta', value: th.codigoProposta },
          { name: 'search', value: '' },
        ],
      };

      th.$api.Multiplo.ListCCBDigitalAssinatura(dtoAssinantes).then(assinantes => {
        if (th.$api.UI.PostLoadData(assinantes)) {
          th.$set(th, 'listBase', assinantes.Data.filter(el => el.Documento === th.$api.UI.Format.SomenteAlfanumerico(th.assinante.DocumentoFederal)));
          th.model = th.listBase.map((item) => { return { Descricao: item.Descricao, PapelID: item.PapelID } });
          if (th.listBase.length > 0) th.assinaCCB = true;
        }
      });
    },
    retiraPapeis () {
      const th = this;
      if (!th.assinaCCB) {
        th.model = []
      } else {
        th.model = th.listBase.map((item) => { return { Descricao: item.Descricao, PapelID: item.PapelID } });
      }
    }
  },
}
</script>
  <style scoped>
  </style>
